export default __webpack_public_path__ + "images/21_1_image.jpg";